import React, { useRef, useState } from 'react';
import {
  FilterPod,
  TableComponents,
  TableItemActionsNew,
  ConfirmDialog,
  ButtonLoading,
  Icons,
  PageContainer,
} from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { useStyles } from './style';
import { Box, Grid, Menu, MenuItem } from '@mui/material';
import jMoment from 'moment-jalaali';
import InitFilters from './constants/InitFiltering';
import Services from './services/GrantPermissionRequestsServices';
import { columns, generateData } from './components/Columns';
import { enifyNumber, numberTester } from '../../../utility';
import { useLocation } from 'react-router-dom';
import createToast from 'components/Toast/Toast';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

const GrantPermissionRequests = () => {
  // -- STATES --//
  const {
    loading,
    setLoading,
    cancelingRequest,
    setCancelingRequest,
    isConfirmOpen,
    setIsConfirmOpen,
    selectedRowToDelete,
    setSelectedRowToDelete,
    filterParams,
    setFilterParams,
    size,
    setSize,
    page,
    setPage,

    selectedRowToConfirm,
    setSelectedRowToConfirm,
  } = useCustomHook();


  const actionsList =
    getDynamicObjectAction([
      'permissionsGuildBtn',
      'permissionsUpdateGuildBtn',
      'permissionsDeleteGuildBtn',
      'permissionsCancelGuildBtn'
    ])
  // It should be declared here cause of hirearchy!
  const getAccounts = async (val) => {
    if (val?.length >= 2) {
      try {
        const q = {
          size: 10,
          offset: 0,
        };

        const enifiedValue = enifyNumber(val);
        q[numberTester.test(enifiedValue) ? 'businessId' : 'query'] = enifiedValue;

        const result = await Services.getBusinessList(q);
        const data = result.result;
        let list = [];
        list = data.map((val) => ({
          name: val.name,
          id: val.id,
          label: `${val.name} (شناسه: ${val?.id})`,
          value: val.id,
        }));
        return list;
      } catch (e) {
        return [];
      }
    }
  };
  const [filters, setFilters] = useState(InitFilters(getAccounts));
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  // --HOOKS--//

  const tableRef = useRef();
  const location = useLocation();
  // --API REQUESTS--//
  const getRequestsData = async (query) => {
    try {
      setLoading(true);

      // TODO: Handle Order By (is not provided by server side)
      const orderBy = [];

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      jMoment.loadPersian({ usePersianDigits: false });
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      // بررسی میکند داخل آدرس بار  کوئری استرینگ گیلد کد وجود دارد  و اگه وجود داشته باشد داخل سرویس جستجو استفاده میشود
      const searchParams = new URLSearchParams(location.search);
      const guildCode = searchParams.get('guildCode');
      const walletCode = searchParams.get('wallet');
      if (guildCode) {
        params = {
          ...params,
          guildCode: guildCode,
        };
      }
      if (walletCode) {
        params = {
          ...params,
          wallet: walletCode,
        };
      }
      //////=================================================
      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getPermission(params);

      let list = [];
      if (res.result) {
        list = generateData(res?.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const confirmRequest = async (rowData) => {
    try {
      setLoading(true);
      await Services.confirmGrantPermission(rowData?.id);
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const revokeService = async (rowData) => {
    try {
      setLoading(true);
      await Services.revokeGrantPermission(rowData?.id);

      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const deleteService = async (rowData) => {
    try {
      setLoading(true);
      setCancelingRequest(true);
      await Services.deleteGrantPermission(rowData?.id);
      createToast('موفق', 'درخواست با موفقیت حذف شد!', 'success');
      setPage(0)
      setSize(10)
      handleCloseDialog();
      setCancelingRequest(false);
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (e) {
      setCancelingRequest(false);
    } finally {
      setLoading(false);
    }
  };

  const onDeleteReq = (rowData) => {
    setSelectedRowToDelete(rowData ?? null);
    setIsConfirmOpen(!!rowData);
  };

  const handleCloseDialog = () => {
    setSelectedRowToDelete(null);
    setSelectedRowToConfirm(null);

    setIsConfirmOpen(false);
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };
  const hint =
    'در پلتفرم کسب وکار، از طریق ایجاد مجوز برای کسب وکار دیگر، این امکان وجود دارد که آن کسب وکار دسترسی انجام عملیات مالی از جمله: کلیه عملیات مربوط به فاکتور، انتقال وجه، درخواست تسویه حساب، درخواست موجودی و درخواست صورتحساب مورد نظر را بر روی کسب وکار شما داشته باشد. همچنین این امکان وجود دارد که مجوزهای صادر شده، به طور کامل حذف یا به صورت موقت لغو شود و در صورت تمایل با تایید مجدد، فعال گردد.';

  // -- LOCAL VARIABLES--//
  return (
    <PageContainer
      title="مجوزهای مالی"
      pageKey="grantPermissionRequests"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.GRANT_PERMISSION_LIST}
    >
      {actionsList['permissionsGuildBtn'] && (
        <>
          <Grid item xs={12}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>

          <TableComponents
            data={getRequestsData}
            columns={columns(actionsList, cancelingRequest, confirmRequest, onDeleteReq, revokeService)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getRequestsData(ps)
            }}
          />
        </>
      )}
      <ConfirmDialog
        open={isConfirmOpen}
        onClose={handleCloseDialog}
        loading={cancelingRequest}
        onConfirm={() => deleteService(selectedRowToDelete)}
        title="تایید حذف مجوز"
        content={`آیا از حذف مجوز مورد نظر اطمینان دارید؟`}
        confirmButtonText="بله، حذف مجوز"
        cancelButtonProps="انصراف"
      />
    </PageContainer>
  );
};

// See detail for every row

const TableItemActions = ({ otherMenus, startIcon, title }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  // --HOOKS--//
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // --API--//

  return (
    <div className={classes.otherActions}>
      <ButtonLoading
        variant="outlined"
        onClick={handleClick}
        color="primary"
        startIcon={startIcon ?? null}
        name={title ?? 'عملیات'}
        aria-controls="simple-menu"
        aria-haspopup="true"
      />

      <Menu
        id="simple-menu"
        className={classes.otherActionsMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
      >
        {otherMenus.map((v, k) => (
          <MenuItem
            className={classes.otherActionsMenuItem}
            key={k}
            disabled={v?.disabled}
            onClick={() => {
              if (v?.disabled) return;
              v?.onClick?.();
              handleClose();
            }}
          >
            {v?.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default GrantPermissionRequests;
